/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M16.0316 7.9684c.3985-.836.2516-1.8671-.4406-2.5594-.5657-.5657-1.3577-.7672-2.0846-.6045l1.6491-1.6491c1.4393-1.4393 3.7001-1.5606 5.2758-.3616l.4403.335.335.4403a4.019 4.019 0 0 1 .155.2185c1.0307 1.561.8569 3.6837-.5166 5.0572l-1.6497 1.6497c.1631-.7271-.0384-1.5196-.6043-2.0855-.6923-.6922-1.7233-.8391-2.5594-.4406Zm.4381 1.5013a.75.75 0 1 1 1.0606 1.0606l-1.4053 1.4053 1.8753 1.8752 3.9054-3.9053c1.8872-1.8873 2.1232-4.8006.7077-6.9444a5.488 5.488 0 0 0-.2131-.3004L23.78 1.2811c.2929-.293.2936-.7685.0007-1.0614a.75.75 0 0 0-1.0607 0L21.3396 1.6c-2.1648-1.6473-5.2677-1.4824-7.2447.4946l-3.9054 3.9054 1.8749 1.8749 1.4053-1.4053a.75.75 0 0 1 1.0606 1.0607L13.125 8.9355l1.9394 1.9394 1.4053-1.4053Zm-3.1895 4.2498a.7496.7496 0 0 1 0 1.0607l-1.3447 1.3447 1.875 1.875-3.9054 3.9054c-1.977 1.977-5.08 2.1419-7.2447.4946L1.28 23.7803a.75.75 0 0 1-1.0607 0c-.2929-.2929-.2922-.7685.0007-1.0614l1.3797-1.3796a5.5376 5.5376 0 0 1-.213-.3004c-1.4155-2.1438-1.1796-5.0571.7076-6.9444l3.9054-3.9053 1.875 1.875 1.3448-1.3447a.7494.7494 0 0 1 1.0606 0 .7498.7498 0 0 1-.0006 1.0613l-1.344 1.3441 1.9393 1.9393 1.3447-1.3447a.7496.7496 0 0 1 1.0607 0Zm-7.2805-1.409 5.6895 5.6894-2.8448 2.8447a4.0069 4.0069 0 0 1-2.4912 1.1629c-1.144.1003-2.3227-.2873-3.1982-1.1629-1.571-1.5711-1.571-4.1183 0-5.6894l2.8447-2.8447Z"
    clipRule="evenodd"
  />,
  'Configuration'
);
